var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main",attrs:{"id":"main","role":"main"}},[_c('Hero',{attrs:{"site_data":_vm.site_data.hero}}),_vm._v(" "),_c(_vm.site_data.pagetype,{tag:"component",attrs:{"site_data":_vm.site_data,"is_mobile":_vm.is_mobile}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218f2272","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Base.vue
// module id = null
// module chunks = 